<template>
    <GMapMap ref="gMap" :center="center" :zoom="11" class="listing-map">
        <GMapCircle v-if="enableSearchPoint" key="searchAreaCircle" ref="searchAreaCircle" :center="searchPointCenter" :radius="24140.2" :options="searchAreaCircleOptions"></GMapCircle>
        <GMapCircle v-if="enableSearchPoint" key="searchRadiusCircle" ref="searchRadiusCircle" :center="searchPointCenter" :radius="40233.6" :options="searchRadiusCircleOptions"></GMapCircle>
        <GMapMarker v-if="enableSearchPoint" icon="/listings/locations-components/img/map-pin-search.png" key="searchPoint" :position="center" :draggable="true" :clickable="true" :zIndex="getZIndex('searchPoint')" @click="openMarker('searchPoint')" @drag="searchPointDrag" @dragend="searchPointDragEnd">
            <GMapInfoWindow :opened="openedMarker === 'searchPoint'" :closeclick="true" @closeclick="closeMarker('searchPoint')">
                <h3>Search Point</h3>
                <p>Drag this pin to move your search point. This will run a new search based on the new location of the pin</p>
            </GMapInfoWindow>
        </GMapMarker>

        <GMapMarker v-for="listing in listings" :key="listing.id" :icon="getIcon(listing)" :position="getCoord(listing)" :clickable="true" :zIndex="getZIndex(listing)" @click="openMarker(listing.id)">
            <GMapInfoWindow :opened="openedMarker == listing.id" :closeclick="true" @closeclick="closeMarker(listing.id)">
                <h3>{{ listing.name }}</h3>

                <div class="address">
                    <hours-status :listing="listing"></hours-status>
                    {{ listing.location.line1 }}<br />
                    {{ listing.location.line2 }}
                </div>
                <p><a :href="'#' + listing.id" title="Scroll to listing" @click="showListing(listing)" v-smooth-scroll="{ updateHistory: false, offset: -50 }">Show in Results</a></p>
            </GMapInfoWindow>
        </GMapMarker>
    </GMapMap>
</template>

<script>import script from './Map';
    export default script;</script>
